import {
  ITelemetryDataItem,
  TelemetryDataItemServer
} from 'shared/entities/telemetry';

export class TelemetryDataItemModel implements ITelemetryDataItem {
  readonly path: string;
  readonly date: Date;

  constructor(params: ITelemetryDataItem) {
    this.path = params.path;
    this.date = params.date;
  }

  toJson(): TelemetryDataItemServer {
    return {
      url: this.path,
      date: this.date.toISOString()
    };
  }
}
